import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../Static.css";
import { useTranslation } from "react-multi-lang";

const AboutUs = () => {
  const t = useTranslation("static_pages.about_us");

  return (
    <>
      <Helmet>
        <script src="//in.fw-cdn.com/32218506/1186004.js" chat="true"></script>
      </Helmet>
      <div className="static-pag-sec">
        <div className="static-page-header">
          <Container fluid>
            <Row className="justify-content-center">
              <Col md="9">
                <div className="static-section-title">
                  <h1>{t("title")}</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Container fluid>
          <div className="static-box">
            <Row>
              <Col md={12}>
                <div className="static-card">
                  <h4>{t("title")}</h4>
                  <p>{t("heading")}</p>

                  <h4>{t("what_we_offer.title")}</h4>
                  <ul>
                    <li>
                      <strong>
                        {t("what_we_offer.instant_crypto_conversions.title")}
                      </strong>{" "}
                      {t("what_we_offer.instant_crypto_conversions.content")}
                    </li>
                    <li>
                      <strong>
                        {t("what_we_offer.currency_exchange.title")}
                      </strong>{" "}
                      {t("what_we_offer.currency_exchange.content")}
                    </li>
                    <li>
                      <strong>
                        {t("what_we_offer.user_friendly_platform.title")}
                      </strong>{" "}
                      {t("what_we_offer.user_friendly_platform.content")}
                    </li>
                    <li>
                      <strong>{t("what_we_offer.security.title")}</strong>{" "}
                      {t("what_we_offer.security.content")}
                    </li>
                  </ul>

                  <h4>{t("join_us_title")}</h4>
                  <p>{t("join_us_subtitle")}</p>
                  <div className="call-to-action-btn-sec">
                    <Link className="new-default-primary-btn" to="/contact-us">
                      {t("contact_us")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="#171717"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                          stroke-width="1.5"
                          d="M14.43 5.93L20.5 12l-6.07 6.07M11.01 12h9.32M3.5 12h3.47"
                        ></path>
                      </svg>
                    </Link>
                    {/* <Link className="new-default-primary-btn" to={-1}>
                      {t("back")}
                    </Link> */}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default AboutUs;
